export const STYLE_CONTANER = {
  minHeight: "100%",
  backgroundColor: "#ffffff",
  color: '#000000'
};
export const STYLE_TEXT = {
  minHeight: "100px",
  backgroundColor: "#f5f5f5",
  padding: "10px",
  fontSize: "20px",
  color: '#000000'
};
export const STYLE_PICTURE = {
  minHeight: "100px",
  backgroundColor: "#f5f5f5",
  padding: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const STYLE_DIV = {
  minHeight: "100px",
  backgroundColor: "#cccccc",
};
export const STYLE_HEADER = {
  minHeight: "100px",
  backgroundColor: "#fa8072",
  color: '#000000',
  textAlign: 'center',
  fontSize: "40px",
  lineHeight: '1',
  fontWeight: '500',
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const STYLE_FOOTER = {
  minHeight: "100px",
  backgroundColor: "#9898ff",
  color: '#000000',
  textAlign: 'center',
  fontSize: "40px",
  lineHeight: '1',
  fontWeight: '500',
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
};
export const STYLE_COMBO = {
  minHeight: "100px",
  backgroundColor: "#f5f5f5",
  color: '#000000',
  fontSize: "20px",
  wordBreak: "break-all",
  padding: "10px",
};
